import { Navigate } from 'react-router';

const RedirectRoutes = {
  path: '*',
  element: <Navigate to="/campaigns" />
};

export default RedirectRoutes;
